<div #dropdown
     class="dropdown-menu ace-con ace-con-inline"
     [class.show]="open"
     [style.top]="dropdownPosition?.top"
     [style.left]="dropdownPosition?.left"
     clickOutside
     (clickOutside)="closeDropdown()">
    <slot name="dropdown-content">
        <span class="dropdown-content" slot="dropdown-content">
            @if (!renderedTop) {
                @if (selectConfig && selectConfig.canSearch && selectConfig.options.length >= selectConfig.includeSearchAfterN) {
                    <div
                        class="filter">
                        <div class="search">
                            <div class="prepend">
                                <ws-ace-icon glyph="search"></ws-ace-icon>
                            </div>
                            <input type="text" autocomplete="off" placeholder="Search" #searchInput
                                   [(ngModel)]="searchValue" (input)="search()">
                        </div>
                    </div>
                }
            }
            @if (selectConfig && selectConfig.canDeselect) {
                <button
                    class="option"
                    data-qa="ace-select-deselect-option"
                    (click)="optionSelected(selectConfig.deselectValue)">
                    <span class="content">
                        {{ selectConfig.deselectLabel }}
                    </span>
                </button>
            }
            @for (option of selectConfig?.searchableOptions; track $index; let groupIndex = $index) {
                @if (option.group && option.items?.length) {
                    <div class="group">
                        <div class="group-heading">
                            {{ option.group }}
                        </div>
                        @for (item of option.items; track $index; let itemIndex = $index) {
                            <button
                                class="option"
                                [attr.data-qa]="'ace-select-option-' + groupIndex + '-' + itemIndex"
                                [class.active]="item === selectConfig.selectedOption"
                                [class.disabled]="item[selectConfig.disabledProperty]"
                                (click)="optionSelected(item)">
                                <span class="content"
                                      [ngClass]="(selectConfig.optionStyleClass && selectConfig.optionStyleClass(item[selectConfig.valueProperty]))"
                                      [ngStyle]="{ 'text-align': selectConfig.alignOptionText }"
                                      [title]="((selectConfig.isPrimitive) ? item : item[selectConfig.labelProperty])">
                                    {{ ((selectConfig.isPrimitive) ? item : item[selectConfig.labelProperty]) }}
                                </span>
                            </button>
                        }
                    </div>
                }
                @if (!option.group) {
                    <button
                        class="option"
                        [attr.data-qa]="'ace-select-option-' + $index"
                        [class.active]="option === selectConfig.selectedOption"
                        [class.disabled]="option[selectConfig.disabledProperty]"
                        (click)="optionSelected(option)">
                        <span class="content"
                              [ngClass]="(selectConfig.optionStyleClass && selectConfig.optionStyleClass(option[selectConfig.valueProperty]))"
                              [ngStyle]="{ 'text-align': selectConfig.alignOptionText }"
                              [title]="((selectConfig.isPrimitive) ? option : option[selectConfig.labelProperty])">
                            {{ ((selectConfig.isPrimitive) ? option : option[selectConfig.labelProperty]) }}
                        </span>
                    </button>
                }
            }

            @if (!searchValue && (selectConfig?.isShowMoreFromParent || (selectConfig?.maxListSize && selectConfig?.searchableOptions.length < searchResultCount))) {
                <button
                    class="option"
                    data-qa="ace-select-show-more"
                    (click)="showMore($event)">
                    <span class="content show-more"><i class="fa fa-caret-down"></i> Show More</span>
                </button>
            }
            @if (renderedTop) {
                @if (selectConfig && (selectConfig.options.length < selectConfig.includeSearchAfterN || !selectConfig.canSearch)) {
                    <button
                        class="option bottom">
                        @if (!selectConfig.selectedOption) {
                            <span class="content">{{ selectConfig.placeholder }}</span>
                        }
                        @if (selectConfig.selectedOption) {
                            <span class="content"
                            >{{ (selectConfig.isPrimitive) ? selectConfig.selectedOption : selectConfig.selectedOption[selectConfig.labelProperty] }}</span>
                        }
                    </button>
                }
                @if (selectConfig && selectConfig.canSearch && selectConfig.options.length >= selectConfig.includeSearchAfterN) {
                    <span
                        class="search-option bottom">
                        <span class="content">
                            <label class="select-search-label">
                                <input class="exclude-modal-styling" #searchInput type="text" [(ngModel)]="searchValue"
                                       (input)="search()"/>
                                <i class="fa fa-search"></i>
                            </label>
                        </span>
                    </span>
                }
            }
        </span>
    </slot>
</div>
